import { QUESTION_TYPE } from '../../fetchSurvey/constants/questionTypes';
import type { Survey, SurveyPage } from '../../fetchSurvey/types';
import type { McqQuestion } from '../../fetchSurvey/types/mcq';
import type { AnswerValue, SurveyAnswers } from '../../submitSurvey/types';

function hasMcqSelection(mcq: McqQuestion, value: AnswerValue | undefined): boolean {
  if (mcq.selectionMode === 'multiple') {
    return Array.isArray(value) && value.length > 0;
  }
  return value !== undefined && value !== null && value !== '';
}

function defaultMcqValue(mcq: McqQuestion): AnswerValue {
  if (mcq.selectionMode === 'multiple') {
    return [...mcq.defaultOptionIds!];
  }
  return mcq.defaultOptionIds![0];
}

export function applyMcqDefaults(pages: SurveyPage[], answers: SurveyAnswers): SurveyAnswers {
  let changed = false;
  const next = { ...answers };

  for (const page of pages) {
    for (const question of page.questions) {
      if (question.type !== QUESTION_TYPE.MCQ) continue;

      const mcq = question as McqQuestion;
      if (!mcq.defaultOptionIds?.length) continue;
      if (hasMcqSelection(mcq, next[mcq.id])) continue;

      next[mcq.id] = defaultMcqValue(mcq);
      changed = true;
    }
  }

  return changed ? next : answers;
}

export function buildInitialAnswers(survey: Survey): SurveyAnswers {
  return applyMcqDefaults(survey.pages, {});
}
